import { Redirect } from 'react-router';
import useTranslation from '../../hooks/useTranslations';
import SidebarWrapper from '../private/layouts/partials/SidebarWrapper';
import BusinessAreaScreen from '../private/screens/businessArea/BusinessAreaScreen';
import FolderScreen from '../private/screens/folder/FolderScreen';
import { setDocumentTitle } from './SetDocumentTitle';

const MainRoutes = ({ activeTree }) => (
	<>
		<SidebarWrapper activeTree={activeTree} showNavigation hideForMobile />
		<Content activeTree={activeTree} />
	</>
);

export default MainRoutes;

const Content = ({ activeTree }) => {
	const t = useTranslation();

	if (activeTree.businessArea && activeTree.folder1 && activeTree.folder2 && activeTree.folder3) {
		// setDocumentTitle([t(activeTree.businessArea.translationkey), t(activeTree.folder1.translationkey), t(activeTree.folder2.translationkey), t(activeTree.folder3.translationkey)]);
		setDocumentTitle([t(activeTree.folder3.translationkey)]);
		return <FolderScreen activeTree={activeTree} />;
	}
	if (activeTree.businessArea && activeTree.folder1 && activeTree.folder2) {
		// setDocumentTitle([t(activeTree.businessArea.translationkey), t(activeTree.folder1.translationkey), t(activeTree.folder2.translationkey)]);
		setDocumentTitle([t(activeTree.folder2.translationkey)]);
		return <FolderScreen activeTree={activeTree} />;
	}
	if (activeTree.businessArea) {
		setDocumentTitle([t(activeTree.businessArea.translationkey)]);
		return <BusinessAreaScreen activeTree={activeTree} />;
	}

	return <Redirect to="/" />;
};
